import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";
import React from "react";

import EmailTemplate from "../../../FormComponents/EmailTemplate";
import Spinner from "../../../Fundamentals/Spinner/Spinner";

const SubscriptionTerminationEmailTemplate = ({form, onChange }) => {
    const { t } = useTranslation();
    const user = useSelector(state => state.CommonReducer.user);

    if (!form || !form.data) return <Spinner />

    return <EmailTemplate data={form.data} onChange={onChange} />
} 

export default SubscriptionTerminationEmailTemplate;